import React, { FC } from "react";
import MainLayout from "../../Layouts/MainLayout";

interface LogDetails {
  summary: string;
  id: string;
  agent: string;
  taskType:string,
  taskDescription: string;
  expectedOutput: string;
  response: string;
  created_at: string;
  updated_at: string;
}

const LogsDetails: FC = () => {
  const logsDetails: LogDetails[] = [
    {
      summary: "Task 57 in General Task",
      id: "57",
      agent: "Code generator",
      taskType:'2',
      taskDescription: "Email crew",
      expectedOutput: "As an experienced can you create php code",
      response: "Here’s a complete React component that renders the provided content with specified styling and includes a navigation feature",
      created_at: "Dec. 20, 2024, 9:46 a.m.",
      updated_at: "Dec. 20, 2024, 9:46 a.m.",
    },
  ];

  return (
    <MainLayout>
      <div className="logs-details">
        <h4>User Logs</h4>
        <ul style={{listStyle:'none'}}>
          {logsDetails.map((log) => (
            <li key={log.id}>
              <div>
                <p><strong>Summary: </strong> {log.summary}</p>
                <p><strong>Id: </strong> {log.id}</p>
                <p><strong>Task type: </strong> {log.taskType}</p>
                <p><strong>Agent:</strong> {log.agent}</p>
                <p><strong>Task description: </strong> {log.taskDescription}</p>
                <p><strong>Expected Output:</strong> {log.expectedOutput}</p>
                <p><strong>Created_at:</strong> {log.created_at}</p>
                <p><strong>Updated_at:</strong> {log.updated_at}</p>
                
              </div>
            </li>
          ))}
        </ul>
      </div>
    </MainLayout>
  );
};

export default LogsDetails;
